import * as flags from 'util/flags';

var profile = {};

profile.privacyBanner = ($banner) => {
    const confirmViewedPrivacyBanner = () => {
        return new Promise((resolve) => {
            flags.update('viewed_privacy_banner', true, resolve);
        })
    };

    $banner.find('a').on('click', (e) => {
        e.preventDefault();
        confirmViewedPrivacyBanner().then(() => {
            window.location.href = e.currentTarget.href;
        });
    });

    $banner.find('button').on('click', () => {
        confirmViewedPrivacyBanner();
        $banner.hide();
    });
};


// vkeys
// --------------------------------------------------

window.vkey.profile_stats_sidebar = function (action, action_key) {
    var root = vkey.handle(action, action_key);
    root.find('.upvotes').tooltip();
};

var profile_handler = function (action, action_key) {
    var root = vkey.handle(action, action_key);
    profile_init(root);
    if(root.find('.error').length === 0) {
        var $saved = root.find('.saved:not(.animating)');
        if($saved.length > 0) {
            $saved.addClass('animating');
            $saved.fadeIn(200).delay(3000).fadeOut(200).removeClass('animating');
        }
    }
    root.find('input:not([type=submit]):not([type=radio]):visible:first').focus();
};

// profile fields
//window.vkey.profile_profile = profile_handler;
window.vkey.profile_about = profile_handler;

module.exports = profile;
